/**
 * 车辆生效范围工具
 *
 * 层级：views/MapEditor/utils（表单业务纯函数）
 *
 * 职责：
 * 1. 归一化 vehicleLimit，过滤接口/表单残留的空字符串、null、undefined
 * 2. 避免 antd Select multiple 将空值渲染成一个无文案的已选 tag
 *
 * 不关心地图 SDK、React 生命周期和接口请求。
 */
export const normalizeVehicleLimit = (value: unknown): string[] | undefined => {
  if (!Array.isArray(value)) return undefined;

  const normalized = value.filter(
    (item): item is string => typeof item === 'string' && item.trim().length > 0
  );

  return normalized.length > 0 ? normalized : undefined;
};
